import React, { useEffect, useState } from "react";
import axios from "axios";

const Titles = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    axios.get('https://ethiccraft.org/backend/activity_tiles/read_isShown.php') // Replace with your actual API endpoint
      .then(res => {
        if (Array.isArray(res.data)) {
          // Take at least 9 images for the 3x3 grid, if available
          setImages(res.data.slice(0, 12).map(item => item.image));
        }
      })
      .catch(err => console.error("Failed to load images:", err));
  }, []);

  const imagesBeforeCenter = images.slice(0, 5);
  const imagesAfterCenter = images.slice(5, 12); // Ensure we don't go beyond 9 images

  return (
    <div className="Titles-container">
      <div className="Titles-Image-grid">
        {imagesBeforeCenter.map((src, index) => (
          <div key={index} className="Title-item" data-aos="fade-up">
            <img src={`https://ethiccraft.org/${src}`} alt={`Ethiccraft activity ${index + 1}`} />
          </div>
        ))}

        <div className="Title-center" data-aos="zoom-in">
          <h1 className="metro-title">Lead - Serve - Transform</h1>
          <p className="metro-subtitle">The way of Ethiccraft Leaders</p>
        </div>

        {imagesAfterCenter.map((src, index) => (
          <div key={index + 5} className="Title-item" data-aos="fade-up">
            <img src={`https://ethiccraft.org/${src}`} alt={`Ethiccraft activity ${index + 6}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Titles;